export const schools = [
  {
    name: '東京工科大学',
    faculties: [
      {
        name: 'デザイン学部',
        departments: [],
      },
      {
        name: '医療保健学部',
        departments: [],
      },
    ],
  },
  {
    name: '日本工学院',
    faculties: [
      {
        name: 'クリエイターズカレッジ',
        departments: [
          { name: '放送芸術科' },
          { name: '演劇スタッフ科' },
          { name: '声優・演劇科' },
          { name: 'マンガ・アニメーション科 2年制／4年制' },
        ],
      },
      {
        name: 'デザインカレッジ',
        departments: [
          { name: 'ゲームクリエイター科 2年制／4年制' },
          { name: 'ゲームプログラミング科' },
          { name: 'デザイン科' },
          { name: 'CG映像科' },
        ],
      },
      {
        name: 'ミュージックカレッジ',
        departments: [
          { name: 'ミュージックアーティスト科' },
          { name: '音響芸術科' },
          { name: 'コンサート・イベント科' },
          { name: 'ダンスパフォーマンス科' },
        ],
      },
      {
        name: 'ITカレッジ',
        departments: [
          { name: 'ITスペシャリスト科' },
          { name: '情報処理科' },
          { name: '情報ビジネス科' },
          { name: 'AIシステム科' },
          { name: 'ネットワークセキュリティ科' },
          { name: 'ホテル・観光科' },
        ],
      },
      {
        name: 'テクノロジーカレッジ',
        departments: [
          { name: '電子・電気科' },
          { name: '機械設計科' },
          { name: '建築学科' },
          { name: '建築設計科' },
        ],
      },
    ],
  },
  {
    name: '日本語学校',
    faculties: [
      {
        name: 'ワールドフレンズ',
        departments: [],
      },
    ],
  },
];
